<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.executor" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td>Дата замоноличивания</td>
          <td>Наименование стыков и узлов, место или номер по чертежу или схеме</td>
          <td>Заданные бетона (раствора) и рабочий состав бетонной (растворной) смеси</td>
          <td>Температура наружного воздуха, °С</td>
          <td>Температура предварительного обогрева элементов в узлах, °С</td>
          <td>Температура бетона в момент укладки, °С</td>
          <td>Результат испытания контрольных образцов</td>
          <td>Дата распалубки</td>
          <td>Фамилия и инициалы исполнителя (бригадира), подпись</td>
          <td>Замечания производителя работ, авторского надзора, технического надзора заказчика</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td></td>
        </tr>
      </template> 
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
      <template #remark="{item}">
        {{ item.remark }}
        <c-journal-sign :sign="getSign(item, 'approver')" />
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.publishedAt, 'date') }}
      </template>
      <template #strippingDate="{item}">
        {{ $app.date.format(item.strippingDate, 'date') }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        executor: $app.auth.can('journals_spec8_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'date', title: '', },
        { name: 'title', title: '', },
        { name: 'compound', title: '', },
        { name: 'weather', title: '', },
        { name: 'temperatureBefore', title: '', },
        { name: 'temperature', title: '', },
        { name: 'result', title: '', },
        { name: 'strippingDate', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'remark', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'spec5')
        .query({
          'with[author][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
